import { Alert, Center, Container, Loader, Stack } from '@mantine/core';
import BreadcrumbsComponent from 'components/BreadcrumbsComponent';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import CreateMasterPlanForm from 'modules/pages/dacum/reviewMasterplan/CreateMasterPlanForm';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { pathnames } from 'routes/dacum';
import { masterPlanService } from 'services/dacum/masterPlan.service';

const EditMasterPlanPage = () => {
  const [searchParams] = useSearchParams();
  const jobFamily = searchParams.get('jobfamily') || '';
  const year = searchParams.get('year') || '';
  const masterplanId = searchParams.get('masterplanId') || '';
  const { appName } = useAppName();
  const pageContent = PAGES[appName]?.reviewMasterPlan;

  const breadcrumbs = [
    { title: 'Review Masterplan', href: pathnames.reviewMasterPlan },
    { title: 'Edit Master Plan', href: '' }
  ];

  const {
    data: responseData,
    isPending,
    error
  } = useQuery({
    queryKey: ['masterPlanDetail', jobFamily, year, masterplanId],
    queryFn: () => masterPlanService.getMasterPlanDetail({ jobFamily, year, masterplanId }),
    enabled: Boolean(jobFamily && year && masterplanId)
  });

  // Extract the first masterplan from the list (should only be 1 for edit)
  const data = responseData?.listMasterplan?.[0];

  if (!jobFamily || !year || !masterplanId) {
    return (
      <Alert color='red'>
        Master plan parameters (job family, year, masterplan ID) are missing.
      </Alert>
    );
  }

  return (
    <Container fluid>
      <Stack>
        <BreadcrumbsComponent items={breadcrumbs} mb={16} />
        <PageTitle
          title={pageContent?.title ? `${pageContent.title} - Edit` : 'Edit Master Plan'}
          description={pageContent?.description || ''}
        />
        {isPending ? (
          <Center py='xl'>
            <Loader />
          </Center>
        ) : error ? (
          <Alert color='red'>Unable to load master plan detail. Please try again later.</Alert>
        ) : !data ? (
          <Alert color='yellow'>Master plan detail is not available.</Alert>
        ) : (
          <CreateMasterPlanForm mode='edit' initialData={data} />
        )}
      </Stack>
    </Container>
  );
};

export default EditMasterPlanPage;
